import React from 'react'
import {makeStyles} from '@material-ui/core/styles'
import {getClasses} from '../../helpers/mergeStylesHelper'
import Lk from '../lk/Lk'
import LkHeader from '../lk/LkHeader'
import LkHeaderAppend from '../lk/LkHeaderAppend'
import LkBody from '../lk/LkBody'
import EntityList from '../EntityList'
import {ReactComponent as BasketIcon} from '../../assets/icons/basket.svg'
import {colors} from '../../styles/colors'


const styles = {
  Root: {},
  CheckBoxText: {
    color: colors.black
  },
  BodyBottom: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    marginTop: 30
  },
  LeftButtonToolbar: {
    background: colors.blue
  },
  BasketButton: {
    border: 'none',
    background: 'none',
    cursor: 'pointer'
  },
  BasketIcon: {
    '& path': {
      stroke: colors.red,
      fill: colors.white
    }
  }
}
const useStyles = makeStyles(styles)

export default function LkOperatorTaksoparkaEmployees(props) {
  const classes = getClasses(props.classes, useStyles(props), styles)

  const tableData = [
    {
      fio: 'Колесников И.П.',
      phone: '+7 936 1234573',
      position: 'Медик',
      status: 'Активен',
      delete: 'id'
    },
    {
      fio: 'Колесников И.П.',
      phone: '+7 936 1234573',
      position: 'Медик',
      status: 'Активен',
      delete: 'id'
    },
    {
      fio: 'Колесников И.П.',
      phone: '+7 936 1234573',
      position: 'Медик',
      status: 'Активен',
      delete: 'id'
    },
    {
      fio: 'Колесников И.П.',
      phone: '+7 936 1234573',
      position: 'Медик',
      status: 'Активен',
      delete: 'id'
    },
  ]

  return (
    <Lk classes={classes}>
      <LkHeader title={'оператор таксопарка'} append={
        <LkHeaderAppend
          title='Личный кабинет'
          backLink={'/some'}
        />
      } />

      <LkBody activeTab={'employees'} type={'operator-taksoparka'}>
        <EntityList
          topToolbarSearchWidth={600}
          data={tableData}
          toolbarButtonText={'Добавить сотрудника'}
          toolbarLeftButtonClassName={classes.LeftButtonToolbar}
          columns={[
            {title: 'ФИО', field: 'fio', align: 'center'},
            {title: 'Телефон', field: 'phone', align: 'center'},
            {title: 'Позиция', field: 'position', align: 'center'},
            {title: 'Статус', field: 'status', align: 'center'},
            {
              title: 'Удалить запись',
              field: 'delete',
              align: 'center',
              render: () => (
                <button className={classes.BasketButton}>
                  <BasketIcon className={classes.BasketIcon} />
                </button>
              )
            },
          ]}
        />
      </LkBody>
    </Lk>
  )
}